import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  margin: 0 auto 75px auto;
  background: var(--dark);
  overflow: hidden;

  .row-container {
    padding: 0 22px;
  }

  h2,
  p {
    color: white;
  }

  h2 {
    margin-bottom: 35px;
    font-size: 44px;
  }

  p {
    margin-bottom: 40px;
    font-size: var(--font-size-20);
    max-width: 350px;
  }

  a {
    max-width: 350px;

    @media (min-width: 992px) {
      &:hover {
        background: white !important;
        color: black !important;
      }
    }
  }

  @media (max-width: 991px) {
    a:hover {
      background: rgba(0, 0, 0, 0.3);
    }
  }

  .col-grid-container {
    margin: 0 auto;
  }

  @media (max-width: 767px) {
    text-align: center;

    h2 {
      font-size: 28px;
      max-width: 280px;
      margin: 0 auto 25px auto;
    }

    p {
      max-width: 100%;
      font-size: var(--font-size-mobile-p-md);
      margin-bottom: 0;
    }

    a {
      width: 100%;
      max-width: 100%;
      margin: 40px 0 60px 0 !important;
    }
  }
`;

const InnerContainer = styled.div`
  width: 100%;
  max-width: var(--max-width);
  margin: 0px auto;
  padding: var(--container-padding);
  position: relative;

  @media (max-width: 767px) {
    padding: 75px 18px 0;
  }
`;

export { Container, InnerContainer };
